let addon = (function ($) {
  $(".scroll-to-form").click(function () {
    $('html, body').animate({
      scrollTop: $("#getaddon").offset().top
    }, 2000);
  });
})(jQuery);